import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLandingTheme } from '../hooks/useLandingTheme';

const HeroSection: React.FC = () => {
  const { t } = useTranslation();
  const isDark = useLandingTheme();

  return (
    <section
      className={isDark ? 'hero-bg-dark' : 'hero-bg'}
      style={{ paddingTop: '72px' }}
    >
      {/* Content area */}
      <div
        className="flex flex-col items-center"
        style={{ gap: '40px' }}
      >
        {/* Text block: heading + subtitle + CTA */}
        <div
          className="flex flex-col items-center px-6 pt-10 md:pt-20"
          style={{ gap: '24px', maxWidth: '1200px' }}
        >
          {/* Heading row: "Instagram growth," + "automated" side by side */}
          <h1
            className="flex flex-row justify-center items-center flex-wrap text-center"
            style={{ gap: '8px', margin: 0 }}
          >
            <span
              className="font-geist text-[28px] leading-[34px] sm:text-[36px] sm:leading-[40px] md:text-[60px] md:leading-[60px]"
              style={{
                fontWeight: 600,
                color: isDark ? '#FFFFFF' : '#0F172B',
              }}
            >
              {t('landing.hero.title')}
            </span>
            <span
              className={`font-geist text-[28px] leading-[34px] sm:text-[36px] sm:leading-[40px] md:text-[60px] md:leading-[60px] ${isDark ? 'gradient-text-dark' : 'gradient-text'}`}
              style={{ fontWeight: 600 }}
            >
              {t('landing.hero.titleHighlight')}
            </span>
          </h1>

          {/* Subtitle */}
          <p
            className="font-geist text-center text-base md:text-xl"
            style={{
              fontWeight: 400,
              lineHeight: '28px',
              color: isDark ? '#E2E8F0' : '#314158',
              maxWidth: '785px',
            }}
          >
            {t('landing.hero.subtitle')}
          </p>

          {/* CTA Button */}
          <Link
            to="/registration"
            className="gradient-btn inline-flex justify-center items-center bg-fc-gradient-btn text-white font-geist"
            style={{
              fontWeight: 500,
              fontSize: '16px',
              lineHeight: '24px',
              padding: '12px 16px',
              borderRadius: '12px',
            }}
          >
            {t('landing.hero.startTrial')}
          </Link>
        </div>

        {/* Dashboard Preview */}
        <div
          className="w-full flex justify-center px-6"
          style={{ maxWidth: '1200px', margin: '0 auto' }}
        >
          {/* Outer container: clips height, rounded top corners only */}
          <div
            className="h-[200px] md:h-[400px]"
            style={{
              width: '1080px',
              maxWidth: '100%',
              overflow: 'hidden',
              borderRadius: '24px 24px 0 0',
            }}
          >
            {/* Inner card with padding, bg, shadow */}
            <div
              style={{
                padding: '6px',
                background: isDark ? '#1D293D' : '#F8FAFC',
                borderRadius: '18px 18px 0 0',
                boxShadow: isDark
                  ? '0px 0px 75px rgba(2, 6, 24, 0.5)'
                  : '0px 0px 75px rgba(43, 127, 255, 0.1)',
              }}
            >
              <img
                src={isDark ? '/images/landing/dashboard-dark.png' : '/images/landing/dashboard-light.png'}
                alt="Famous Clicker Dashboard"
                className="w-full h-auto block"
                style={{ borderRadius: '12px 12px 0 0' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
